import { css as t } from "@microsoft/fast-element";
import { designTokens as o } from "../design-tokens.js";
import { hostSelectorState as i, selectorState as n } from "./utils.js";
import { typography as l } from "./typography.js";
const p = (r) => t`
  ${r} {
    /* Base */
    min-height: ${o.spacing[10]};
    /* Layout */
    /* padding - border (border-box only works with fixed sizes) */
    padding: calc(0.438 * ${o.spacing[4]})
      calc(0.938 * ${o.spacing[4]});
    align-items: flex-start;
    gap: ${o.spacing[2]};
    align-self: stretch;
    flex-wrap: wrap;
    /* Style */
    border-radius: ${o.borderRadius.sm};
    border: ${o.borderWidth.xs} solid
      ${o.color.neutral[70]} !important;
    background-color: ${o.color.white};
    color: ${o.color.neutral[400]};
    /* Transition */
    transition: border-color ${o.transition.fast},
      background-color ${o.transition.fast},
      color ${o.transition.fast};
  }

  ${i(r, ":disabled")} {
    /* Style */
    background-color: ${o.color.neutral[40]};
    color: ${o.color.neutral[100]};
  }

  ${i(r, ":focus-within")} {
    /* Style */
    border-color: ${o.color.primary[100]} !important;
  }

  ${i(r, ".invalid")} {
    /* Base */
    border-color: ${o.color.error[60]} !important;
  }
`, $ = (r) => t`
  ${i(r, ".invalid")} {
    /* Base */
    color: ${o.color.error[90]};
  }

  ${r} {
    /* Style */
    color: ${o.color.neutral[100]};
    /* Typography */
    ${l("label", "regular")}
  }
`, u = (r) => t`
  ${r} {
    /* Layout */
    flex-grow: 1;
    /* Typography */
    ${l("p", "regular")}
  }
`, y = (r) => t`
  ::slotted(nova-icon) {
    /* Layout */
    width: ${o.iconSize.md} !important;
    height: ${o.iconSize.md} !important;
    /* Style */
    color: inherit;
  }

  ::slotted(.validation-icon) {
    /* Style */
    color: ${o.color.error[90]};
  }
`, g = (r, a) => t`
  :host {
    /* Layout */
    flex-direction: column;
    align-items: flex-start;
    gap: ${o.spacing[2]};
  }

  ${r} {
    /* Layout */
    display: flex;
  }

  ${a} {
    /* Base */
    border: none;
    padding: 0;
    background-color: transparent;
    color: inherit;
    max-width: 100%;
  }

  ${n(a, "::placeholder")} {
    /* Style */
    color: ${o.color.neutral[100]};
    opacity: 1;
  }

  ${n(a, ":focus-visible")} {
    /* Style */
    outline: none;
  }
`;
export {
  p as inputControlStyles,
  $ as inputHintStyles,
  g as inputHostWithNativeControlStyles,
  y as inputIconStyles,
  u as inputTextStyles
};
